export const COVER_STRINGS = {
  bringToLife: 'Bring This Home To Life',
};
